import IEnvironmentService from '@/app/Service/EnvironmentService/Contract/IEnvironmentService';

class EnvironmentService implements IEnvironmentService {
  getBackendHost = (): string => process.env.VUE_APP_BACKEND_HOST;
}

export default EnvironmentService;
